import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaCheck, FaShieldAlt, FaBug, FaRobot } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AnimatedBackground from "../components/AnimatedBackground";

import cyberbg1 from '../Assets/Cyberbg1.png';
import cyberbg2 from '../Assets/Cyberbg2.png';
import cyberbg4 from '../Assets/Cyberbg4.png';

import "./Cybersecurity.css";

const Cybersecurity = () => {
  /* Core services */
  const services = [
    {
      title: "Penetration Testing",
      icon: <FaBug />,
      description:
        "Simulated cyber‑attacks designed to reveal vulnerabilities in AI pipelines & infrastructure.",
      points: [
        "AI‑model attack simulations",
        "Data‑poisoning resistance tests",
        "Model‑extraction defence validation",
      ],
    },
    {
      title: "Cybersecurity Auditing",
      icon: <FaShieldAlt />,
      description:
        "Deep‑dive audits to ensure your AI models meet global security & compliance standards.",
      points: [
        "Regulatory‑gap analysis",
        "Security‑architecture assessment",
        "Privacy‑control evaluation",
      ],
    },
    {
      title: "AI Firewall",
      icon: <FaRobot />,
      description:
        "Real‑time defence powered by proprietary AI algorithms against sophisticated adversarial threats.",
      points: [
        "Continuous threat monitoring",
        "Anomaly‑detection engine",
        "Predictive vulnerability analysis",
      ],
    },
  ];


  /* ──────────────────────────────────────── */
  return (
    <div className="cybersecurity-container">
      <AnimatedBackground />
      <Navbar />

      {/* ▸ Hero */}
      <header
        className="cybersecurity-hero cyber-page-section" style={{
          backgroundImage: `url(${cyberbg1})`,
        }}
      >
        <motion.h1
          className="cybersecurity-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.5 }}
          transition={{ duration: 0.7 }}
        >
          Cybersecurity & AI-System Security
        </motion.h1>

        <motion.p
          className="cybersecurity-description"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.5 }}
          transition={{ duration: 0.7 }}
        >
          Protect your AI systems and sensitive data with comprehensive,
          battle‑tested security solutions.
        </motion.p>


      </header>

      {/* ▸ Services */}
      <section
        id="services"
        className="cybersecurity-services cyber-page-section" style={{
          backgroundImage: `url(${cyberbg2})`,
        }}
      >
        <motion.h2
          className="section-heading accent"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: false }}
        >
          Our Core Security Services
        </motion.h2>
        <div className="services-grid">
          {services.map((svc, idx) => (
            <motion.article
              key={svc.title}
              className="service-card glass"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.25 }}
              transition={{ duration: 0.6, delay: idx * 0.12 }}
            >
              <span className="service-icon">{svc.icon}</span>
              <h3>{svc.title}</h3>
              <p>{svc.description}</p>

              <ul className="check-list">
                {svc.points.map((pt) => (
                  <li key={pt}>
                    <FaCheck className="check-ico" /> {pt}
                  </li>
                ))}
              </ul>
            </motion.article>
          ))}
        </div>
      </section>

      {/* ▸ CTA */}
      <section
        className="cyber-cta-section cyber-page-section" style={{
          backgroundImage: `url(${cyberbg4})`,
        }}
      >
        <motion.div
          className="cyber-cta glass"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: false }}
        >
          <h3>Ready to secure your AI assets?</h3>
          <p>
            Chat with our experts to learn how Sapiencia.AI can fortify your AI pipeline today.
            your AI pipeline today.
          </p>

          <Link className="cta-btn" to="/contact">
            Request Demo →
          </Link>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
};

export default Cybersecurity;